import { ReactNode, useMemo, useState } from "react";
import { VendedoresList } from "./VendedorList";
import { CreateVendedorForm } from "./CreateVendedorForm";
import { VendedorDetails } from "./VendedorDetails";
import { useAdminPanelUI } from "../../../hooks/useAdminPanelUI";

export enum VendedorActions {
    VendedoresList = "VendedoresList",
    CreateVendedorForm = "CreateVendedorForm",
    VendedorDetails = "VendedorDetails",
}

export function VendedoresContainer() {
    const { vendedorActions } = useAdminPanelUI();
    const [vendedorSelectedId, setVendedorSelectedId] = useState<number>(0);

    const actions: Record<string, ReactNode> = useMemo(() => ({
        "VendedoresList": <VendedoresList
                        setVendedorSelected={setVendedorSelectedId} />,
        "CreateVendedorForm": <CreateVendedorForm
                                setVendedorSelected={setVendedorSelectedId} />,
        "VendedorDetails": <VendedorDetails
                                vendedorId={vendedorSelectedId} />
    }), [vendedorSelectedId]);

    const currentAction = actions[vendedorActions];

    return (
        <div className="h-full w-full">
            {currentAction}
        </div>
    );
}